
import React from "react";
import { useNavigate } from "react-router-dom";
import HeavenlyLoader from "./HeavenlyLoader";

const LoadingScriptures: React.FC = () => {
  const navigate = useNavigate();
  
  const handleClose = () => {
    navigate(-1); // Go back to previous page when closed
  };

  return <HeavenlyLoader message="Loading Bible text..." onClose={handleClose} />;
};

export default LoadingScriptures;
